import { socket } from './config';
import { storageCreator } from '../utils';

export default {
  pay: (options, onSuccess, onError) => {
    var widget = new window.cp.CloudPayments();
    widget.auth({
      ...options,
      skin: 'mini',
    },
      function (options) {
        onSuccess({ options });
      },
      function (reason, options) {
        onError({ reason, options });
      });
  },
  setPaymentResult: (success, options, reason = undefined) => {
    const localStore = storageCreator(() => localStorage);
    const dialogId = localStore.getItem('dialogId');

    const variables = {
      input: {
        dialog_id: Number(dialogId),
        success,
        reason,
        options
      }
    };

    const query = JSON.stringify(
      {
        message: `mutation ($input: SetPaymentResultInput) {
          setPaymentResult(input: $input) {
            message_id
            dialog_id
            timestamp
            timestamp_received
            is_read
            is_delivered
            sender {
              sender_id
              name
              picture_path
              type_id
            }
            content
            data
            message_uuid
          }
        }`,
        variables,
        queryName: 'setPaymentResult',
      }
    );
    socket.emit('graphql', query);
  },
}
